/**
 * Detects if we are in development mode.
 * - In Vite: import.meta.env.DEV is injected by the dev server and
 *   statically replaced in production builds
 * - In Jest: uses the global __DEV__ defined in jest.config.js
 */

declare const __DEV__: boolean | undefined;

// Function that checks the environment
// Jest defines __DEV__ as a global, Vite uses import.meta.env.DEV
export const checkDevEnv = (): boolean => {
    // In Jest, __DEV__ is defined as a global
    if (typeof __DEV__ !== 'undefined') {
        return __DEV__;
    }

    // In Vite, import.meta.env.DEV is available at compile time
    return import.meta.env.DEV;
};
